module.exports = __webpack_public_path__ + "static/media/bp22.bb81a056.jpg";